import { lazy, Suspense, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import FallbackLoading from '../../FallbackLoading';
import LogoBox from '../../LogoBox';
import SimplebarReactClient from '../../wrappers/SimplebarReactClient';
import { filterMenuItemsByPermissions, getMenuItems, getWhatsAppMenuItems } from '../../../helpers/menu';
import { isWhatsAppPath } from '../../../helpers/whatsapp';
import { useAuth } from '../../../context/AuthContext';
import HoverMenuToggle from './components/HoverMenuToggle';

const AppMenu = lazy(() => import('./components/AppMenu'));

const VerticalNavigationBar = () => {
  const { admin } = useAuth();
  const { pathname } = useLocation();
  const menuItems = useMemo(() => {
    const items = isWhatsAppPath(pathname) ? getWhatsAppMenuItems() : getMenuItems();
    return filterMenuItemsByPermissions(items, admin);
  }, [admin, pathname]);
  return (
    <div className="main-nav" id="leftside-menu-container">
      <div className="logo-box logo-box-row">
        <LogoBox
          containerClassName="logo-box"
          squareLogo={{ className: 'logo-sm' }}
        />
        <HoverMenuToggle />
      </div>
      <SimplebarReactClient className="scrollbar">
        <Suspense fallback={<FallbackLoading />}>
          <AppMenu menuItems={menuItems} />
        </Suspense>
      </SimplebarReactClient>
    </div>
  );
};

export default VerticalNavigationBar;
